import { createReducer, on } from '@ngrx/store';
import { DetalleFactura } from '../actions/detalleFactura.actions';

export interface State {
    params: any,
}

export const initialState: State = {
    params:null,
};

const _DetalleFacturaReducer = createReducer(
    initialState,
    on(DetalleFactura, (state, payload) => ({
        ...state,
        params: payload.params,
    })),
    //on(DetalleFacturaLimpiar, (state) => initialState),
);

export function DetalleFacturaReducer(state, action) {
    return _DetalleFacturaReducer(state, action);
}
